import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../../app/firebase";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchArticles,
  fetchArticleCategories,
  fetchArticlePetTags,
  selectArticles,
  selectArticlesLoading,
  selectArticleError,
  selectArticleCategories,
  selectArticlePetTags,
} from "../../../features/articles/articlesSlice";
import AdminArticles from "./adminArticles";

export default function AdminArticlesContainer() {
  const dispatch = useDispatch();
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const articles = useSelector(selectArticles);
  const loading = useSelector(selectArticlesLoading);
  const error = useSelector(selectArticleError);
  const categories = useSelector(selectArticleCategories);
  const petTags = useSelector(selectArticlePetTags);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCheckingAdmin(true);
      setIsAdmin(false);
      if (!user) {
        setCheckingAdmin(false);
        return;
      }
      try {
        const token = await user.getIdTokenResult(true);
        setIsAdmin(!!token.claims.admin);
      } finally {
        setCheckingAdmin(false);
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      dispatch(fetchArticles());
      dispatch(fetchArticleCategories());
      dispatch(fetchArticlePetTags());
    }
  }, [dispatch, isAdmin]);

  const handleRefresh = () => {
    dispatch(fetchArticles());
    dispatch(fetchArticleCategories());
    dispatch(fetchArticlePetTags());
  };

  if (checkingAdmin) return <div style={{ padding: 16 }}>Checking admin rights…</div>;
  if (!isAdmin) return <div style={{ padding: 16 }}>403 — Admin access only</div>;

  return (
    <AdminArticles
      articles={articles}
      loading={loading}
      error={error}
      onRefresh={handleRefresh}
      articleCategories={categories}
      articlePetTags={petTags}
    />
  );
}
